import type { UserJourney } from '../../../shared/types/UserJourney';
import headerConfig from '../../UnifiedPaymentForm/UnifiedPaymentFormHeader/utils/headerConfig';

export const getSycurioPageSubTitle = (
  userJourney: UserJourney,
) => headerConfig[userJourney].CARD.agent.phoneEntry.subTitle;
